import { memo, useState } from "react";
import axios from "../../customAxios";
import { ListItem, Button, Chip } from "@mui/material";
import { getDeliveryStatus } from "../../utils/functions";

const WebhookItem = ({
  webhook,
  handleSnack,
  setSelectedWebhook,
  showDrawer,
  setIsEditing,
  setWebhooks,
}) => {
  const [statuses] = useState(getDeliveryStatus());
  const handleDeleteConfig = async (event) => {
    event.preventDefault();
    try {
      const { status } = await axios.delete(`companies/setting_webhooks/delete/${webhook.id}`);
      if (status >= 200 && status < 300) {
        setWebhooks((prev) => prev.filter((w) => w.id !== webhook.id));
      } else {
        handleSnack(true, "Error al procesar la solicitud");
        console.error(status);
      }
    } catch (error) {
      console.error(error);
      handleSnack(true, error.response?.data?.error || "Error desconocido");
    }
  };

  const getUserStatusName = (systemName) => {
    return statuses.find((status) => systemName === status.system_name)
      .user_name;
  };

  const getUserSubStatusName = (statusName, systemName) => {
    return statuses
      .find((status) => status.system_name === statusName)
      .substatus.find((substatus) => substatus.system_name === systemName)
      .user_name;
  };

  const handleOpenConfig = (event) => {
    event.preventDefault();
    setSelectedWebhook(webhook);
    setIsEditing(true);
    showDrawer(event);
  };

  return (
    <ListItem
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "space-around",
        alignItems: "center",
        py: 1.5,
      }}
    >
      <Chip
        label={`${getUserStatusName(webhook.status)} / ${getUserSubStatusName(
          webhook.status,
          webhook.substatus
        )}`}
        color="primary"
        className="staked-chip staked-fixed-width"
        variant="outlined"
      />
      <Button
        variant="outlined"
        size="small"
        onClick={handleOpenConfig}
        sx={{ mr: 2, color: "#1976d2", borderColor: "#1976d2", maxWidth: 200 }}
      >
        Abrir configuración
      </Button>
      <Button
        variant="outlined"
        size="small"
        onClick={handleDeleteConfig}
        sx={{
          color: "#d32f2f !important",
          borderColor: "#d32f2f !important",
          mr: 2,
          maxWidth: 80,
        }}
      >
        Eliminar
      </Button>
    </ListItem>
  );
};

export default memo(WebhookItem);
